<section class="tg-terminos-hero">
  <div class="tg-container">
    <span class="tg-terminos-eyebrow">Legal · TG Empleos</span>
    <h1>Términos y Aviso de Privacidad</h1>
    <p>Tratamiento de datos personales para candidatos de TG Empleos.</p>
  </div>
</section>

<section class="tg-terminos-content">
  <div class="tg-container tg-terminos-card">

    <h2>1. Responsable del tratamiento</h2>
    <p>
      <strong>I.T. Quality Services, S.A. de C.V. — Tec Gurus</strong>, responsable de TG Empleos,
      recaba, almacena, consulta, actualiza y utiliza la información que proporciones dentro de la plataforma
      para fines de creación de perfil, búsqueda de empleo, análisis curricular, postulación a vacantes,
      generación de recomendaciones y contacto relacionado con oportunidades laborales.
    </p>

    <h2>2. Datos que se recaban</h2>
    <p>
      La información que podrás proporcionar incluye: nombre, apellidos, fecha de nacimiento, género, fotografía,
      correo electrónico, número de WhatsApp, país, zona horaria, especialización, salario deseado, disponibilidad
      para viajar, disponibilidad para mudarte, redes sociales, historial académico, experiencia laboral,
      certificaciones, habilidades, idiomas, nivel de conocimientos, descripción profesional, C.V. y cualquier otro
      dato que captures voluntariamente dentro de TG Empleos.
    </p>

    <h2>3. Finalidades del tratamiento</h2>
    <p>
      TG Empleos utilizará tu información y tu C.V. para analizar tu perfil profesional, mejorar tu C.V. con
      herramientas de inteligencia artificial, identificar vacantes compatibles con tu experiencia, mostrar
      recomendaciones personalizadas, generar coincidencias con oportunidades laborales y enviarte alertas o
      notificaciones relacionadas con empleos, postulaciones, suscripción, planes o servicios de la plataforma.
    </p>

    <h2>4. Procesamiento con inteligencia artificial</h2>
    <p>
      Autorizas que TG Empleos pueda procesar tu información mediante herramientas tecnológicas propias o de
      terceros, incluyendo servicios de inteligencia artificial, con la finalidad de analizar tu C.V., extraer
      información profesional, mejorar la presentación de tu perfil, generar recomendaciones, comparar tu perfil
      con vacantes disponibles y ofrecer una mejor experiencia dentro de la plataforma.
    </p>

    <h2>5. Compartir con empresas y reclutadores</h2>
    <p>
      Cuando actives la opción <em>"Mostrar mis datos a las empresas"</em>, cuando te postules a una vacante o
      cuando utilices funciones de vinculación laboral dentro de TG Empleos, tu perfil, información profesional,
      datos de contacto y C.V. podrán ser compartidos con empresas, reclutadores, clientes, aliados comerciales o
      posibles empleadores, nacionales o extranjeros, exclusivamente para fines de reclutamiento, evaluación de
      perfiles, contacto laboral, entrevistas, seguimiento de postulaciones o vinculación con oportunidades de empleo.
    </p>
    <p>
      Reconoces que puedes desactivar la opción <em>"Mostrar mis datos a las empresas"</em> desde tu perfil, sin
      perjuicio de que la información previamente enviada en postulaciones o procesos de reclutamiento ya iniciados
      pueda haber sido consultada por las empresas o reclutadores correspondientes.
    </p>

    <h2>6. Veracidad y titularidad</h2>
    <p>
      Declaras que la información que proporciones es veraz, actual, completa y de tu titularidad.
      Te comprometes a no cargar información falsa, documentos de terceros, datos que no te pertenezcan o
      contenido que vulnere derechos de otras personas.
    </p>

    <h2>7. Datos sensibles dentro del C.V.</h2>
    <p>
      Reconoces que tu C.V. puede contener información personal adicional a la solicitada por TG Empleos.
      En caso de incluir datos personales sensibles —como información de salud, discapacidad, origen étnico,
      creencias, opiniones políticas, información sindical, datos biométricos, orientación sexual u otros datos
      sensibles—, aceptas que dichos datos fueron proporcionados voluntariamente por ti y otorgas tu consentimiento
      expreso para que sean tratados únicamente en la medida necesaria para el uso de tu C.V. y tu perfil laboral.
      Se recomienda no incluir datos sensibles que no sean necesarios para procesos de reclutamiento.
    </p>

    <h2>8. Sin garantías de contratación</h2>
    <p>
      Entiendes que TG Empleos es una plataforma de apoyo, análisis, recomendación y vinculación laboral, por lo
      que el uso del servicio no garantiza entrevistas, contratación, respuesta de empresas, aceptación en vacantes
      ni resultados específicos en procesos de selección.
    </p>

    <h2>9. Conservación y revocación</h2>
    <p>
      Tus datos personales podrán conservarse mientras tu cuenta permanezca activa, mientras exista una relación de
      uso con la plataforma o durante el tiempo necesario para cumplir con finalidades legales, administrativas, de
      seguridad, soporte, historial de postulaciones o atención de solicitudes. Podrás solicitar la eliminación,
      cancelación u oposición al tratamiento de tus datos conforme al Aviso de Privacidad vigente.
    </p>

    <h2>10. Derechos ARCO</h2>
    <p>
      Podrás ejercer tus derechos de acceso, rectificación, cancelación u oposición, así como revocar tu
      consentimiento, enviando una solicitud al correo
      <a href="mailto:empleos@tecgurus.net">empleos&#64;tecgurus.net</a> o
      <a href="mailto:contacto@tecgurus.net">contacto&#64;tecgurus.net</a>,
      indicando tu nombre completo, correo registrado y el derecho que deseas ejercer.
    </p>

    <h2>11. Aviso de Privacidad de Tec Gurus</h2>
    <p>
      Estos términos son complementarios al
      <a [href]="privacyUrl" target="_blank" rel="noopener">Aviso de Privacidad de Tec Gurus</a>,
      que rige el tratamiento de datos personales por parte de I.T. Quality Services, S.A. de C.V.
    </p>

  </div>
</section>
